import React from "react";

import image1 from "../../assets/images/resource/drinkMenu/1.webp";
import image2 from "../../assets/images/resource/drinkMenu/2.webp";
import image3 from "../../assets/images/resource/drinkMenu/3.webp";
import image4 from "../../assets/images/resource/drinkMenu/4.webp";
import image5 from "../../assets/images/resource/drinkMenu/5.webp";
import image6 from "../../assets/images/resource/drinkMenu/6.webp";
import image7 from "../../assets/images/resource/drinkMenu/7.webp";
import image8 from "../../assets/images/resource/drinkMenu/8.webp";
import image9 from "../../assets/images/resource/drinkMenu/9.webp";
import image10 from "../../assets/images/resource/drinkMenu/10.webp";
import image11 from "../../assets/images/resource/drinkMenu/11.webp";
import image12 from "../../assets/images/resource/drinkMenu/12.webp";
import image13 from "../../assets/images/resource/drinkMenu/13.webp";
import image14 from "../../assets/images/resource/drinkMenu/14.webp";
import image15 from "../../assets/images/resource/drinkMenu/15.webp";
import image16 from "../../assets/images/resource/drinkMenu/16.webp";
import image17 from "../../assets/images/resource/drinkMenu/17.webp";
import image18 from "../../assets/images/resource/drinkMenu/18.webp";
import image19 from "../../assets/images/resource/drinkMenu/19.webp";

function Menu() {
  const menuItems = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16,
    image17,
    image18,
    image19,
  ];
  return (
    <>
      <section className="menu-one">
        <div className="auto-container">
          <div class="outer-container">
            <div class="row clearfix">
              {menuItems.map((i) => (
                <div class="image-col col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <div
                    class="inner wow fadeInLeft"
                    data-wow-duration="1500ms"
                    data-wow-delay="0ms"
                  >
                    <div class="" style={{ textAlign: "center" }}>
                      <img src={i} style={{ width: "90%" }} alt="" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Menu;
